import { getTreeIncidentStatusTotalsQuery } from '../../../services/api';
import { createGqlBatcher } from '../../../services/batchers/gqlBatcher';
import type {
  Filter,
  IncidentV2StatusCounts,
  Query,
  TreeCategory,
  TreeViewType,
} from '../../../services/gql/types';

export type TreeIncidentStatusTotalsBatchContext = {
  gqlEndpoint: string;
  accessToken: string;
  category: TreeCategory;
  view: TreeViewType;
  daysBack: number;
  filters: Filter[];
};

export type TreeIncidentStatusTotalsBatchItem = {
  requestId: string;
  assetId?: string;
  path?: string;
};

function batchKey(ctx: TreeIncidentStatusTotalsBatchContext): string {
  return JSON.stringify({
    gqlEndpoint: ctx.gqlEndpoint,
    accessToken: ctx.accessToken,
    category: ctx.category,
    view: ctx.view,
    daysBack: ctx.daysBack,
    filters: ctx.filters,
  });
}

const { enqueue: enqueueTreeIncidentStatusTotalsBatch } = createGqlBatcher<
  TreeIncidentStatusTotalsBatchContext,
  TreeIncidentStatusTotalsBatchItem,
  Pick<Query, 'treeIncidentStatusTotals'>,
  IncidentV2StatusCounts
>({
  windowMs: 150,
  maxBatch: 50,
  query: getTreeIncidentStatusTotalsQuery,
  batchKey,
  endpoint: (ctx) => ctx.gqlEndpoint,
  authToken: (ctx) => ctx.accessToken,
  itemRequestId: (item) => item.requestId,
  buildVariables: (ctx, items) => ({
    category: ctx.category,
    view: ctx.view,
    daysBack: ctx.daysBack,
    items: items.map((item) => ({
      requestId: item.requestId,
      assetId: item.assetId ?? null,
      path: item.path ?? null,
    })),
    filters: ctx.filters.length ? ctx.filters : undefined,
    excludeResourceTypes: ['exposure'],
  }),
  parseResponse: (data) =>
    new Map(
      data.treeIncidentStatusTotals.map((row) => [
        row.requestId,
        row.statusCounts,
      ]),
    ),
});

export { enqueueTreeIncidentStatusTotalsBatch };
